export default "__VITE_ASSET__BoeQtj28__"